import { SSN_EMPTY_MASK } from 'utility/constants';
import { licenseNumberRegex, ssnRegex } from 'utility/regex';

export const HsmvPhotoCheckValidatorFactory = () => {
  const requiredDriversLicenseNumberText = 'Either Driver\'s License Number or SSN must be entered';
  const requiredSsnText = 'Either Driver\'s License Number or SSN must be entered';
  const requiredDOBText = 'The DOB field is required';
  const requiredJustificationText = 'The Justification field is required';

  return (values) => {
    const validators = {

      requiredSSN: (values.ssn && values.ssn !== SSN_EMPTY_MASK) || values.licenseNumber ? '' : requiredSsnText,
      requiredLicenseNumber: values.licenseNumber || (values.ssn && values.ssn !== SSN_EMPTY_MASK) ? '' : requiredDriversLicenseNumberText,
      requiredDOB: values.dob ? '' : requiredDOBText,
      requiredJustification: values.justification ? '' : requiredJustificationText,

      formatLicenseNumber: (values.licenseNumber ? (licenseNumberRegex.test(values.licenseNumber) ? '' : 'License number not in correct format') : ''),
      formatSSN: (values.ssn && values.ssn !== SSN_EMPTY_MASK ? (ssnRegex.test(values.ssn) ? '' : 'SSN not in correct format') : ''),
      formatDOB: (values.dob ? (Math.floor((new Date().getTime() - new Date(values.dob).getTime())) > 0 && new Date(values.dob).getFullYear() >= 1900) ? '' : 'Enter a valid Date of Birth' : ''),
    };

    return validators;
  };
};
